import { Box, Grid } from '@mui/material'
import FormLabel from '@mui/material/FormLabel'
import React from 'react'
import styled from 'styled-components'

const Label = styled(FormLabel)`
	padding: 0.5rem;
	font-weight: bold;
	color: #000000;
	text-align: center;
	z-index: 0;
`

const ResultsHeader = styled(Grid)`
	line-height: 1.5rem;
	padding-bottom: 1rem;
`

const SearchResultsHeader = ({ resultCount }) => {
  return (
    <ResultsHeader container spacing={1}>
      <Grid item xs={8}>
        <Label>
          <Box align="left">SEARCH RESULTS ({resultCount})</Box>
        </Label>
        <Box fontStyle="italic">
					* Indicates the login info used for the account
        </Box>
      </Grid>
      <Grid item xs={2}>
        <Label name="primaryAccount">
          <div>
						PRIMARY
            <br />
						ACCOUNT
          </div>
        </Label>
      </Grid>
      <Grid item xs={2}>
        <Label>
          <div>
						ACCOUNTS
            <br />
						TO MERGE
          </div>
        </Label>
      </Grid>
    </ResultsHeader>
  )
}

export default SearchResultsHeader
